import { loginModel } from "@/interfaces/account.interface";
import { getUerInfo, login } from "@/api/account.api";
import { getToken, removeToken, setToken } from "@/utils/auth";
import { defineStore } from "pinia";
import { usePermissionStore } from "./permission";
import {
  Role,
  SHINSEISHA_LIST,
  SHONINSHA_LIST,
} from "@/constants/role.constant";

interface UserState {
  email: string;
  role: Role;
  accountId: string;
  token: string | undefined;
}

export const useUserStore = defineStore({
  id: "user",
  state: (): UserState => ({
    email: "",
    role: "" as Role,
    accountId: "",
    token: getToken(),
  }),

  getters: {
    getEmail() {
      return this.email;
    },
    getRole() {
      return this.role;
    },
    getAccountId() {
      return this.accountId;
    },
    getToken() {
      return this.token;
    },
    isShinseisha() {
      return SHINSEISHA_LIST.includes(this.getRole);
    },
    isShoninsha() {
      return SHONINSHA_LIST.includes(this.getRole);
    },
  },

  actions: {
    SetEmail(email: string) {
      this.email = email;
    },
    SetRole(role: Role) {
      this.role = role;
    },
    SetAccountID(accountID: string) {
      this.accountId = accountID;
    },
    SetToken(token: string | undefined) {
      this.token = token;
    },

    async login(userInfo: loginModel) {
      try {
        const res = await login(userInfo);
        const { data } = res;
        const token = data.result;
        console.log(res);
        console.log(token);
        this.SetToken(token);
        //cookie設定
        setToken(token);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async getInfoAction(token: string) {
      try {
        const { data } = await getUerInfo(token);
        const userInfo = data.result;
        this.SetEmail(userInfo.email);
        this.SetRole(userInfo.role);
        this.SetAccountID(userInfo.accountId);
        return userInfo;
      } catch (error) {
        return Promise.reject(error);
      }
    },
    async logout() {
      this.resetToken();
    },
    async resetToken() {
      const permissionStore = usePermissionStore();
      removeToken();
      permissionStore.$reset();
      this.$reset();
    },
  },
});
